import { useEffect, useState } from 'react'
import { PropTypes } from 'prop-types';
import FinCard from '../components/financialAidScholarship/finCard';
import { DecodeHtml } from '../utils/decodeHtml';

const ShowScholarShipCards = ({ scholarship }) => {
    const name = scholarship?.name
    const description = DecodeHtml({ html: scholarship?.description })
    const cards = scholarship?.scholarship
    const initialItemsToShow = 15;
    const [itemsToShow, setItemsToShow] = useState(initialItemsToShow);
    const [length, setLength] = useState(0)
    const [showMore, setShowMore] = useState(true);


    useEffect(() => {
        if (cards) {
            setLength(cards.length)
        }
    }, [cards])


    const handleShowMore = () => {
        if (length > 0) {

            setItemsToShow(itemsToShow + length - 15);
            setShowMore(false);
        }

    }
    const handleShowLess = () => {
        setItemsToShow(initialItemsToShow);
        setShowMore(true);
    };
    return (
        <>
            <span className="self-stretch text-center text-2xl sm:text-3xl text-slate-900  md:text-5xl font-bold ">{name}</span>
            <p className="text-justify md:text-center xl:max-w-5xl text-sky-950 text-opacity-70 text-base font-normal  leading-normal">{description}<br /></p>
            <div className="flex-col  w-full justify-center items-center gap-4 flex">
                {cards?.length > 0 ?
                    <>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {
                                cards?.slice(0, itemsToShow)?.map((card, index) => (
                                    <FinCard key={index} {...card} />
                                ))
                            }
                        </div>
                        {cards.length > initialItemsToShow && (showMore ? (
                            <button onClick={handleShowMore} className="text-sky-600 text-xl font-semibold  underline leading-relaxed">Show More Scholarships</button>

                        ) : (
                            <button onClick={handleShowLess} className="text-sky-600 text-xl font-semibold  underline leading-relaxed">Show Less Scholarships</button>

                        )
                        )
                        }
                    </>
                    :
                    <div className="flex justify-center items-center w-full h-96">
                        <span className="text-2xl text-center font-semibold text-gray-400">No Data Found</span>
                    </div>
                }
            </div>
        </>
    )
}
ShowScholarShipCards.propTypes = {
    scholarship: PropTypes.any
}
export default ShowScholarShipCards